
import React, { useState } from 'react'

import './ContactMenu.scoped.sass'
import ContactPrimaryMenu from './components/Contacts/ContactPrimaryMenu/ContactPrimaryMenu'
import commonsService from '@/services/commons.service'

import useRenderEvent from '@/core/hooks/useRenderEvent'
import { ContactList } from './components/Contacts/ContactList/ContactList'

export function ContactMenu () {
  // eslint-disable-next-line
  const [sideMenuHidden, setSideMenuHidden] = useState(false)
  
  useRenderEvent(['SIDE_MENU:HIDE'], () => {
    setSideMenuHidden(true)
  })

  useRenderEvent(['SIDE_MENU:SHOW'], () => {
    setSideMenuHidden(false)
  })

  function getPrimaryMenu () {
    return (
      <ContactPrimaryMenu />
    )
  }

  return (
    <div className='aside-content' onClick={() => { setSideMenuHidden(true) }} id='contact-menu'>
      {getPrimaryMenu()}
      { !commonsService.isMobile() && <ContactList />}

    </div>
  )
}
